import { useState } from 'react';
import moment from 'moment';
import { apiClient, getToken, getOrgId } from '@devd-client/api';
import {
  PR_CHART_KEYS,
  PR_AGEING_CHARTS,
  PR_HEALTH_INDEX_CHARTS,
  LOC_VS_PR_CYCLE_TIME_CHARTS,
  DEPLOY_CHART_KEYS,
  CFR_CHART_KEYS,
  ISSUE_CHART_KEYS,
  ISSUE_AGE_CHART_KEYS,
  REQUIREMENT_STABILITY_CHARTS,
  ISSUE_LIFECYCLE_DIST_CHARTS,
  WORK_BREAKDOWN_CHARTS,
} from '../../../../shared/utils';

interface UseDownloadCSVProps {
  currentChartMeta: any;
  startDate?: string;
  endDate?: string;
  filterBy: any;
}

export const useDownloadCSV = ({
  currentChartMeta,
  startDate,
  endDate,
  filterBy,
}: UseDownloadCSVProps) => {
  const [pending, setPending] = useState(false);

  const download = (data: any) => {
    const blob = new Blob([data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute(
      'download',
      `${
        currentChartMeta.chartTitle === 'Change Failure Rate'
          ? 'CHANGE_FAILURE_RATE'
          : currentChartMeta?.chartKey === 'CUSTOM'
          ? currentChartMeta?.chartTitle
          : currentChartMeta?.chartKey
      }: ${moment(startDate).format('DD MMM')} - ${moment(endDate).format(
        'DD MMM'
      )}`
    );
    a.click();
  };

  const downloadCSV = async () => {
    setPending(true);
    apiClient(
      `/v1/csv/${
        [
          ...PR_CHART_KEYS,
          ...PR_AGEING_CHARTS,
          ...PR_HEALTH_INDEX_CHARTS,
          ...LOC_VS_PR_CYCLE_TIME_CHARTS,
        ].includes(currentChartMeta?.chartKey)
          ? 'pr'
          : [...DEPLOY_CHART_KEYS].includes(currentChartMeta?.chartKey)
          ? 'deployment'
          : [...CFR_CHART_KEYS].includes(currentChartMeta?.chartKey)
          ? 'cfr'
          : [
              ...ISSUE_CHART_KEYS,
              ...ISSUE_AGE_CHART_KEYS,
              ...REQUIREMENT_STABILITY_CHARTS,
              ...ISSUE_LIFECYCLE_DIST_CHARTS,
            ].includes(currentChartMeta?.chartKey)
          ? 'issue'
          : [...WORK_BREAKDOWN_CHARTS].includes(currentChartMeta?.chartKey)
          ? 'commit'
          : ''
      }/metric/${
        currentChartMeta.chartTitle === 'Change Failure Rate'
          ? 'CHANGE_FAILURE_RATE'
          : currentChartMeta?.chartKey === 'TOP_REVIEWER_DISTRIBUTION'
          ? 'PR_REVIEWED'
          : currentChartMeta?.chartKey === 'PR_CYCLE_TIME_BREAKDOWN'
          ? 'PR_CYCLE_TIME'
          : currentChartMeta?.chartKey
      }`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          authorization: `bearer ${getToken()}`,
        },
        body: JSON.stringify({
          orgId: `${getOrgId()}`,
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          startDate: startDate,
          endDate: endDate,
          ...filterBy,
          vsmAtrributes: { age: filterBy?.age },
        }),
      }
    )
      .then((res: any) => {
        setPending(false);
        download(res);
      })
      .catch((err) => {
        setPending(false);
      });
  };

  return { downloadCSV, pending };
};
